<template>
  <v-dialog v-model="open" persistent max-width="320px">
    <v-card>
      <v-card-title>
        <span>{{ $T('common.set_attribute.title', { attr: $T('attributes.my_birth_month') }) }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <form>
          <v-select
            data-vv-name="year"
            :items="years"
            :label="$T('attributes.year')"
            v-model="year"
            color="clr-primary"
            v-validate="'required'"
            :error-messages="getMessage('year')"
            required
          ></v-select>
          <v-select
            data-vv-name="month"
            :items="months"
            :label="$T('attributes.month')"
            v-model="month"
            color="clr-primary"
            v-validate="'required'"
            :error-messages="getMessage('month')"
            required
          ></v-select>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="clr-btn-cancel" flat @click.native="close">{{ $T('button.close') }}</v-btn>
        <v-btn color="clr-btn" flat @click.native="save" :disabled="!isSavable">{{ $T('button.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: { type: Boolean, required: true },
    initValue: { type: String, required: false },
    apiErrors: { type: Object, required: true },
  },
  data() {
    return {
      dialogKey: 'my_birth_month',
      year: this.initValue ? this.initValue.substr(0, 4) : '',
      month: this.initValue ? this.initValue.substr(4, 2) : '',
    };
  },
  computed: {
    years() {
      let year = new Date().getFullYear();
      let items = [];
      for (let i = 0; i < 120; i++) {
        items.push(year - i);
      }
      return items;
    },
    months() {
      let items = [];
      for (let i = 1; i <= 12; i++) {
        items.push({ text: $T('common.month.' + i), value: i < 10 ? '0' + i : i });
      }
      return items;
    },
    isSavable() {
      return this.isFormDirty && !this.isFormInValid && !this.onSending;
    },
    isFormDirty() {
      return Object.keys(this.fields).some(key => this.fields[key].dirty);
    },
    isFormInValid() {
      return Object.keys(this.fields).some(key => this.fields[key].invalid);
    },
  },
  methods: {
    getMessage(fieldName) {
      return this.apiErrors[fieldName] && this.apiErrors[fieldName][this.inputValue]
        ? this.apiErrors[fieldName][this.inputValue]
        : this.errors.collect(fieldName);
    },
    reValidate() {
      this.$validator.validateAll();
    },
    close() {
      this.$emit('close', this.dialogKey);
    },
    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit('save', this.dialogKey, String(this.year) + String(this.month), this.initValue);
        } else {
          console.warn('there is invalid values.');
        }
      });
    },
  },
};
</script>
